<list-view [liste]="listeReglesAttribution" *ngIf="listeReglesAttribution"></list-view>
<floating-button [listeActions]="listeActions"></floating-button>
